<!-- Loading overlay -->
<div class="cssload-container" *ngIf="loading">
  <div class="cssload-speeding-wheel"></div>
</div>

<!-- Background overlay -->
<div class="background-cover"></div>

<!-- Modal content -->
<div class="move-cost-item-container">
  <div class="header">
    <h3 class="title">{{ 'cost.move.title' | translate }}</h3>
    <p class="subtitle">{{ 'cost.move.subtitle' | translate }}</p>
  </div>

  <div class="cost-item-details">
    <!-- <div class="item-info">
      <div class="item-name">{{ costItem.name }}</div>
      <div class="item-amount">{{ costItem.amount | currency:'USD':'symbol':'1.2-2' }}</div>
      <div class="item-description" *ngIf="costItem.description">
        {{ costItem.description }}
      </div>
    </div> -->
    
    <div class="current-department" *ngIf="costItem">
      <label class="label">{{ 'cost.move.currentDepartment' | translate }}</label>
      <div class="department-badge current">
        {{ getCurrentDepartmentName() }}
      </div>
    </div>
  </div>

  <div class="department-selection">
    <label class="label" for="department-select">
      {{ 'cost.move.selectNewDepartment' | translate }}
    </label>
    <select 
      id="department-select"
      class="department-select"
      [(ngModel)]="selectedDepartmentId"
      [disabled]="loading || disabled">
      <option value="" disabled>{{ 'cost.move.selectDepartment' | translate }}</option>
      <option 
        *ngFor="let dept of departments" 
        [value]="dept.id"
        [disabled]="dept.id === costItem?.department">
        {{ dept.name }} ({{ dept.code }})
      </option>
    </select>
  </div>

  <!-- <div class="selected-department-preview" *ngIf="selectedDepartmentId && selectedDepartmentId !== costItem.department">
    <label class="label">{{ 'cost.move.newDepartment' | translate }}</label>
    <div class="department-badge new">
      {{ getSelectedDepartmentName() }}
    </div>
  </div> -->

  <!-- <div class="warning" *ngIf="selectedDepartmentId && selectedDepartmentId !== costItem.department">
    <div class="warning-icon">⚠️</div>
    <div class="warning-text">
      {{ 'cost.move.warning' | translate }}
    </div>
  </div> -->

  <div class="actions">
    <button 
      type="button"
      class="btn btn-secondary"
      (click)="onCancel()"
      [disabled]="loading">
      {{ 'common.cancel' | translate }}
    </button>
    
    <button 
      type="button"
      class="btn btn-primary"
      (click)="onMoveItem()"
      [disabled]="isMoveDisabled()"
      [class.loading]="loading">
      <span class="spinner" *ngIf="loading"></span>
      {{ 'cost.move.moveItem' | translate }}
    </button>
  </div>
</div>

<!-- <div class="no-item-message" *ngIf="!costItem">
  <p>{{ 'cost.move.noItemSelected' | translate }}</p>
</div> -->
